module.exports = __webpack_public_path__ + "img/skull.9501f33f.png";